import { PATH } from '../../../../../../common/path/puth';

export const salesHeaderMenuItems = [
  { buttonTitle: 'Баланс', buttonLink: PATH.salesBalance },
  { buttonTitle: 'База знаний', buttonLink: PATH.salesKnowledgeBase },
  { buttonTitle: 'Настройки', buttonLink: PATH.salesSettings },
];
